import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { EmailTemplateModel } from '@app/core/models/emails/email-template.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailTemplateService } from '@app/core/services/email-template.service';
import { EmailTemplateType } from '@app/core/models/emails/email-template-type.model';
import { takeUntil } from 'rxjs/operators';
import { EmailModel } from '@app/core/models/emails/email.model';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import * as _ from "lodash";
import { ConfigService } from '@app/core/config/config.service';
@Component({
  selector: 'app-invoice-cancel',
  templateUrl: './invoice-cancel.component.html',
  styleUrls: ['./invoice-cancel.component.scss']
})
export class InvoiceCancelComponent implements OnInit, OnDestroy {

  onConfirm: () => void;

  featureType: EmailTemplateType;
  InvoiceNumber: string;
  InvoiceId: string;

  emailContentBeforeReasonsMarker: string;
  emailContentAfterReasonsMarker: string;
  emailModel: EmailModel;
  emailRequestModel: EmailModel;

  emailTemplates: EmailTemplateModel[];
  emailTemplateDropDownSettings: any;

  selectedEmailTemplate: EmailTemplateModel;
  selectedRejectionReasons: number[];
  recipients: string;

  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  confirmationMessage: string;
  title: string;
  editMode: boolean;

  emailTemplateType: EmailTemplateType;
  hasMultipleTemplates: boolean;

  dynamicPortalUrlMarkerIsMandatory: boolean;
  dynamicAccessCodeMarkerIsMandatory: boolean;

  dynamicReasonsMarker: string;
  dynamicPortalUrlMarker: string;
  dynamicAccessCodeMarker: string;

  dynamicReasonsMarkerFound: boolean;
  dynamicPortalUrlMarkerFound: boolean;
  dynamicAccessCodeMarkerFound: boolean;

  showPickedWarning: boolean;

  constructor(
    private dialogRef: MatDialogRef<InvoiceCancelComponent>,
    public dialog: MatDialog,
    private emailTemplateService: EmailTemplateService,
    private invoiceService: InvoiceService,
    private config: ConfigService,
    @Inject(MAT_DIALOG_DATA) data) {
    this.InvoiceNumber = data.InvoiceNumber;
    this.InvoiceId = data.InvoiceId;
    this.showPickedWarning = data.ShowPickedWarning;
    this.featureType = data.FeatureType;
    this.recipients = data.SupplierEmail;
    this.emailModel = new EmailModel();
    this.selectedEmailTemplate = new EmailTemplateModel();
    this.emailTemplates = [];
    this.selectedRejectionReasons = [];
    this.editMode = false;
    this.dynamicReasonsMarker = this.config.environnement.dynamicReasonsMarker;
    this.dynamicPortalUrlMarker = this.config.environnement.dynamicPortalUrlMarker;
    this.dynamicAccessCodeMarker = this.config.environnement.dynamicAccessCodeMarker;
  }

  ngOnInit(): void {
    this.initContext(this.featureType);
    this.configDropdownLists();

    this.emailTemplateService.getEmailTemplatesByType(this.emailTemplateType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(templates => {
        this.emailTemplates = templates;
        this.hasMultipleTemplates = !_.isNil(templates) && _.size(templates) > 1;

        if (!this.hasMultipleTemplates) {
          this.onSelectTemplate(_.first(templates));
        }
      });
  }

  get AreMarkersValid(): boolean {
    return (!this.dynamicAccessCodeMarkerIsMandatory || this.dynamicAccessCodeMarkerFound)
      && (!this.dynamicPortalUrlMarkerIsMandatory || this.dynamicPortalUrlMarkerFound);
  }

  initContext(featureType: EmailTemplateType) {
    this.emailTemplateType = featureType;
    this.updateMandatoryMarkers(featureType);

    if (featureType === EmailTemplateType.CancelInvoice) {
      this.confirmationMessage = ' Êtes-vous sûr de vouloir envoyer ce mail ?';
      if (this.showPickedWarning) {
        this.confirmationMessage += "<br/><strong>Attention:</strong> Cette facture est prise en charge par un autre utilisateur.";
      }

      this.onConfirm = () => this.cancelInvoice();
      return;
    }

    if (featureType === EmailTemplateType.ReturnToSupplier) {
      this.confirmationMessage = 'Êtes-vous sûr de vouloir renvoyer la facture ?';
      if (this.showPickedWarning) {
        this.confirmationMessage += "<br/><strong>Attention:</strong> Cette facture est prise en charge par un autre utilisateur.";
      }

      this.onConfirm = () => this.sendBackInvoice();
      return;
    }
  }

  onSelectTemplate(data: any): void {
    this.selectedEmailTemplate = this.emailTemplates.find(a => a.Id === data.Id);

    this.emailModel.Title = this.selectedEmailTemplate.Title;
    this.emailModel.Content = this.selectedEmailTemplate.Content;

    this.updateMarkersStatus(this.selectedEmailTemplate.Content);
    const markerIndex = this.selectedEmailTemplate.Content.indexOf(this.dynamicReasonsMarker);

    if (!this.dynamicReasonsMarkerFound) {
      this.emailContentBeforeReasonsMarker = this.selectedEmailTemplate.Content;
      this.emailContentAfterReasonsMarker = null;
      return;
    }

    this.emailContentBeforeReasonsMarker = this.selectedEmailTemplate.Content.substr(0, markerIndex).trim();
    this.emailContentAfterReasonsMarker = this.selectedEmailTemplate.Content.substr(markerIndex + this.dynamicReasonsMarker.length).trim();
  }

  onContentChanged(data): void {
    if (_.isNil(data.html)) {
      return;
    }

    let newContent = data.html;

    this.updateMarkersStatus(newContent);

    this.emailModel.Content = newContent;
    if (!this.dynamicReasonsMarkerFound) {
      this.emailContentBeforeReasonsMarker = newContent;
    } else {
      this.emailContentBeforeReasonsMarker = newContent.substr(0, newContent.indexOf(this.dynamicReasonsMarker)).trim();
      this.emailContentAfterReasonsMarker = newContent.substr(newContent.indexOf(this.dynamicReasonsMarker) + this.dynamicReasonsMarker.length).trim();
    }
  }

  onSelectRejectionReason(data: any, rejectionReasonId: number) {
    if (data.checked) {
      this.selectedRejectionReasons.push(rejectionReasonId);
    }
    else {
      this.selectedRejectionReasons.splice(this.selectedRejectionReasons.indexOf(rejectionReasonId), 1);
    }
  }

  updateMandatoryMarkers(typeIdSelected?: EmailTemplateType | null) {
    this.dynamicAccessCodeMarkerIsMandatory = !_.isNil(typeIdSelected) && typeIdSelected === EmailTemplateType.ReturnToSupplier;
    this.dynamicPortalUrlMarkerIsMandatory = !_.isNil(typeIdSelected) && typeIdSelected === EmailTemplateType.ReturnToSupplier;
  }

  updateMarkersStatus(content: string) {
    this.dynamicReasonsMarkerFound = content.indexOf(this.dynamicReasonsMarker) >= 0;
    this.dynamicAccessCodeMarkerFound = content.indexOf(this.dynamicAccessCodeMarker) >= 0;
    this.dynamicPortalUrlMarkerFound = content.indexOf(this.dynamicPortalUrlMarker) >= 0;
  }

  ensureMarkersAreOk(): boolean {
    if (this.dynamicAccessCodeMarkerIsMandatory && !this.dynamicAccessCodeMarkerFound) {
      this.openMarkerMissingPopup(this.dynamicAccessCodeMarker)
      return false;
    }

    if (this.dynamicPortalUrlMarkerIsMandatory && !this.dynamicPortalUrlMarkerFound) {
      this.openMarkerMissingPopup(this.dynamicPortalUrlMarker)
      return false;
    }

    return true;
  }

  onSubmit(): void {

    if (!this.ensureMarkersAreOk()) {
      return;
    }

    const modalConfig = new ModalHelper().getConfirmationConfig(this.confirmationMessage);
    const dialog = this.dialog.open(ModalComponent, modalConfig);

    dialog.afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(result => {
        if (result) {
          this.onConfirm();
        }
      });
  }

  cancelInvoice(): void {
    this.emailModel.RecipientsTo = this.recipients?.split(';').filter(a => a !== undefined && a.trim().length > 0).map(c => c.trim());

    let requestEmailModel = Object.assign({}, this.emailModel);
    this.handleReasonsMarker(requestEmailModel);

    this.invoiceService.cancelInvoice(this.InvoiceId, requestEmailModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.close(true);
      }, error => {
        this.close(false);
      });
  }

  sendBackInvoice(): void {
    this.emailModel.RecipientsTo = this.recipients?.split(';').filter(a => a !== undefined && a.length > 0);

    let requestEmailModel = Object.assign({}, this.emailModel);
    this.handleReasonsMarker(requestEmailModel);

    this.invoiceService.sendBackInvoice(this.InvoiceId, requestEmailModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.close(true);
      }, error => {
        this.close(false);
      });
  }

  close(isSuccess: boolean) {
    this.dialogRef.close(isSuccess);
  }

  configDropdownLists(): void {
    this.emailTemplateDropDownSettings = new MultiSelectModel().getSettings('Id', 'Label', true);
  }

  onToggleEditMode(editMode: boolean) {
    if (editMode && !this.ensureMarkersAreOk()) {
      return;
    }

    this.editMode = !editMode;
  }

  openMarkerMissingPopup(marker: string) {
    const modalConfig = new ModalHelper().getAlertConfig(`Vous avez supprimé le marqueur <b>${marker}</b> permettant d'ajouter du contenu dynamique à votre email`);
    this.dialog.open(ModalComponent, modalConfig);
  }


  private handleReasonsMarker(requestEmailModel: EmailModel) {
    let selectedRejectionReasonsContent = this.selectedEmailTemplate?.RejectionReasons?.filter(a => this.selectedRejectionReasons.includes(a.Id)).reduce((prev, current) => `${prev}<li>${current.Content}</li>`, '');
    if (selectedRejectionReasonsContent) {
      selectedRejectionReasonsContent = `<ul>${selectedRejectionReasonsContent}</ul>`;
    }
    if (selectedRejectionReasonsContent) {
      requestEmailModel.Content = (this.emailModel.Content?.replace(this.dynamicReasonsMarker, '<p>' + selectedRejectionReasonsContent + '</p>'));
    } else {
      requestEmailModel.Content = (this.emailModel.Content?.replace(this.dynamicReasonsMarker, ''));
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }
}
